export default {
  sm: `
    Energy saving 
    for the 
    environment
  `,
  md: `
    Energy saving for the 
    environment
  `,
  lg: `
    Energy saving for the 
    environment
  `,
};
